import React, { useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import { Box, Button } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { deleteContact, getContact } from '../Store/ActionCreators/ContactActionCreator'
import { DataGrid } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
export default function Contact() {
  const dispatch = useDispatch()
  const contactList = useSelector((state)=>state.ContactStateData)
  const columns = [
    {
    field: "sn",
    headerName: "S.No",
    width: 60,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      return page * pageSize + params.api.getRowIndexRelativeToVisibleRows(params.id) + 1;
    }
    },
    {
      field :"name",
      headerName : "Name",
      width:120
    },
    {
      field :"mobile",
      headerName :"Mobile Number",
      width: 120
    },
    {
      field:"subject",
      headerName:"Subject",
      width:200
    },
    {
      field:"message",
      headerName:"Message",
      width:280
    },
    {
      field:"status",
      headerName:"Status",
      width:80
    },
    {
      field: 'createdAt',
      headerName: 'Create Date',
      width: 150,
      valueFormatter: (value) => {
        if (!value) return '';
        return new Date(value).toLocaleDateString('en-IN', {
          timeZone: 'Asia/Kolkata',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
      },
    },
      {
        field: 'delete',
        headerName: 'Delete',
        width: 120,
        editable: true,
        renderCell: ({ row }) =>
          <Button onClick={() => {
            dispatch(deleteContact({ _id: row._id }))
          }
          }>
            <DeleteIcon style={{color:"red"}}/>
          </Button>
      },
      {
        field: 'view',
        headerName: 'View',
        sortable: false,
        renderCell: ({ row }) =>
          <Button onClick={() => {
            navigate("/contactview/" + row._id)
          }}>
           <VisibilityIcon style={{color:"grayblue"}}/>
          </Button>,
      },
  ]

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate()
  useEffect(()=>{
    dispatch(getContact())
  },[contactList.length,dispatch])
  return (
    <Box sx={{display:"flex"}}> 
      <Sidebar />
      <Box  className="boxStyle">
        <div className="mt-3" >
          <h2 className='text-light bg-success text-center rounded p-1'><i>Contact List</i></h2>
            <h5 className='text-right'style={{textAlign: "right"}}>Total Category : {contactList.length}</h5>
            <Box sx={{ height: 620, width: '100%' }}>
              <DataGrid
                sx={{
                  border: "1px solid #636363ff",
                  "& .MuiDataGrid-cell": {
                    border: "1px solid #dad8d8ff",
                    },
                            "& .MuiDataGrid-columnHeaders": {
                              borderBottom: "1px solid #636363ff",
                            },
                            textAlign:"center"
                          }}
                        
                          rows={contactList}
                          columns={columns}
                          getRowId={(row) => row._id}
                          pageSizeOptions={[5, 10, 20]}
                          pagination
                          paginationModel={{ page, pageSize }}
                          onPaginationModelChange={(model) => {
                            setPage(model.page);
                            setPageSize(model.pageSize);
                          }}
                          localeText={{
                          noRowsLabel: "No Contact Request Available",
                        }}
                        />            
            </Box>
        </div>
      </Box>
    </Box>
  )
}
